import React, { Component } from 'react';
import Viewer from 'react-viewer';

class ImageViewer extends Component {
  handleCloseTab = () => {
    window.close();
  };

  render() {
    const params = new URLSearchParams(window.location.search);
    const link = params.get('link');
    const name = params.get('name');

    if (!link) {
      return (
        <h1>
          Image not found
        </h1>
      );
    }

    return (
      <div className="container-fluid">
        <Viewer
          visible
          noNavbar
          downloadable={false}
          images={[{ src: link, alt: name || '' }]}
          onClose={this.handleCloseTab}
        />
      </div>
    );
  }
}

export default ImageViewer;
